module.exports = __webpack_public_path__ + "img/sb.7bc418dc.png";